import type { FaireProductEntity } from "../../entity_types/product";

export const p_ku693nh8yc: FaireProductEntity = {
  token: "p_ku693nh8yc",
  type: "product",
  name: "I ❤️ Beans Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/7c9ed1b9b87a890e48a40209c3eedd442551496cfed4fc5bc6d47724f98ccabd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/406d01e249a91958e235d9e4f9446aa68065fb82cefd97e678567bb4cf26c9ba.jpeg",
    "https://cdn.faire.com/fastly/42598bafbc685a04f0e7a694b39624b2f90cea565d6d72ca775b23aa324aeb23.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/f8b3bc6832efe1d9d04be16fa5050637bde624b5b78144a25356298f2a73a750.jpeg",
    "https://cdn.faire.com/fastly/9f2953b558d39aa9fdc88ced27688e291425f6b4be1c5c2cc046e26cd402f721.jpeg"
  ],
  priceDollars: 6.75,
  description: "Whether you're into lima, fava, pinto or refried beans... all roads lead to farts! Celebrate your favorite snack (or entrée... we won't judge) and get your fiber the fun way! 💨\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:09.851Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
